import { render, staticRenderFns } from "./dxjtDetail.vue?vue&type=template&id=09442140"
import script from "./dxjtDetail.vue?vue&type=script&lang=js"
export * from "./dxjtDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports